define('modules/form_editor/views/preview_check_item',['require','exports','module','lib/util','base/itemview','lib/markdown','../../editor/models/editorstate','ldsh!../templates/input_check_item_amp','ldsh!../templates/input_check_item'],function(require, exports, module) {
  "use strict";
  var util = require('lib/util'),
      ItemView = require('base/itemview'),
      markdown = require('lib/markdown'),
      EditorState = require('../../editor/models/editorstate');

  module.exports = ItemView.extend({
    template: null,
    tagName: 'label',
    initialize: function(options) {
      this.parentModel = options.parent.model;
      this.inputName = this.parentModel.get('nameAttr');
      this.isRequired = this.parentModel.get('isRequired') || this.model.get('isItemRequired');
      this.elementId = this.getCheckItemID();
      this.template = this.getTemplate();
    },
    getTemplate: function () {
      return EditorState.getAMPState() ?
        require('ldsh!../templates/input_check_item_amp'):
        require('ldsh!../templates/input_check_item');
    },
    className: function() {
      return this.options.parent.itemViewClassName || 'checkbox-inline';
    },
    onRender: function() {
      this.options.parent.addErrorMessages();
      this.$el.i18n();
    },
    helpers: function() {
      return {
        inputName: this.inputName,
        elementId: this.elementId,
        value: this.model.get('value') || this.model.get('text') || '',
        parsedText: markdown(this.model.get('text')),
        isRequired: this.isRequired,
        ampStateId: this.parentModel.get('ampStateId')
      };
    },
    getCheckItemID: function () {
      return this.parentModel.get('elementId') + '-' + util.generateRandom();
    }
  });
});

